import type { MailboxInfo } from 'owa-client-types';
import type TokenResponse from 'owa-service/lib/contract/TokenResponse';
import { lazyLoginUserMsal } from './lazyFunctions';
import { InteractionType } from './utils/InteractionType';
import type { promptForStrongConsumerAuthFunc } from 'owa-auth-callbacks';
import { SA_20MIN_SCOPE } from 'owa-tokenprovider-utils';
import { AccountSourceType } from 'owa-account-source-list-types';
import { logStartUsage } from 'owa-analytics-start';

/**
 * Prompt for an access token for the scope ${SA_20MIN_SCOPE}. Note this may not prompt the user if the token is silently acquired, but caller should expect an interactive UI.
 * @param action. A helpful string, like the one passed to makeServiceRequest, to help identify the context of the request.
 * @param mailboxInfo. Mailbox context to use for this resource token request.
 */
export const promptForStrongConsumerAuth: promptForStrongConsumerAuthFunc = async function (
    action: string,
    mailboxInfo: MailboxInfo
): Promise<TokenResponse | undefined> {
    if (!action) {
        throw new Error('Action must be provided for proper attribution.');
    }

    logStartUsage('PromptForStrongConsumerAuth', mailboxInfo, {
        action,
    });

    return lazyLoginUserMsal.importAndExecute(
        AccountSourceType.OutlookDotCom,
        InteractionType.Popup,
        undefined /* msalAccount */,
        mailboxInfo,
        undefined /* username */,
        undefined /* resource */,
        SA_20MIN_SCOPE,
        'login' /* promptValue */
    );
};
